var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.879 25.121a3 3 0 004.242 0L44.213 6.03a3 3 0 10-4.242-4.242L23 18.757 6.03 1.787a3 3 0 10-4.243 4.242l19.092 19.092zM20 22v1h6v-1h-6z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjg3ODcgMjUuMTIxM0MyMi4wNTAzIDI2LjI5MjkgMjMuOTQ5NyAyNi4yOTI5IDI1LjEyMTMgMjUuMTIxM0w0NC4yMTMyIDYuMDI5NDRDNDUuMzg0OCA0Ljg1Nzg3IDQ1LjM4NDggMi45NTgzNyA0NC4yMTMyIDEuNzg2OEM0My4wNDE2IDAuNjE1MjI0IDQxLjE0MjEgMC42MTUyMjQgMzkuOTcwNiAxLjc4NjhMMjMgMTguNzU3NEw2LjAyOTQ0IDEuNzg2OEM0Ljg1Nzg3IDAuNjE1MjIyIDIuOTU4MzcgMC42MTUyMjIgMS43ODY4IDEuNzg2OEMwLjYxNTIyNCAyLjk1ODM3IDAuNjE1MjI0IDQuODU3ODYgMS43ODY4IDYuMDI5NDRMMjAuODc4NyAyNS4xMjEzWk0yMCAyMkwyMCAyM0wyNiAyM0wyNiAyMkwyMCAyMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgArrowDownWhite as ReactComponent };